<template>
    <div>
        <app-finalizacoes
            :finalizacoes="finalizacoesFiltradas"
            :totaisStatus="totaisStatus"
            v-show="mostrarFinalizacoes"
            @atualizarListagem="obterFinalizacoes()"
        >
            <template slot="controles">
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <strong>
                                <label>Data Atualização (DE)</label>
                            </strong>
                            <date-picker
                                ref="dp01"
                                v-model="dataInicial"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                placeholder="Informe a data inicial"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <strong>
                                <label>Data Atualização (ATÉ)</label>
                            </strong>
                            <date-picker
                                ref="dp02"
                                v-model="dataFinal"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                placeholder="Informe a data final"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <strong>
                                <label>Filtro por Situacao</label>
                            </strong>
                            <b-form-select
                                :plain="true"
                                :options="situacoesFinalizacoesSelect"
                                v-model="situacaoFinalizacoes"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <strong>
                                <label>Filtro por Status</label>
                            </strong>
                            <b-form-select
                                :plain="true"
                                :options="statusFinalizacoesSelect"
                                v-model="statusFinalizacoes"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
            <template slot="acoes" slot-scope="data">
                <span class="text-primary" v-if="$temAcessoView('UABS-FIN-01')">
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="checarDetalharFinalizacao(data)"
                    ></i>
                </span>
            </template>
        </app-finalizacoes>
        <router-view></router-view>
    </div>
</template>

<script>
import FinalizacoesServicos from './FinalizacoesServicos'
import Finalizacoes from '@/app/credenciados/componentes/finalizacoes/Finalizacoes'
import StatusPorSituacao from './StatusPorSituacao'
import { finalizacoesStatus } from './../../componentes/finalizacoes/FinalizacoesStatus'
import { perfil } from './../../SgfPerfis'

export default {
    data() {
        return {
            finalizacoes: [],
            finalizacoesFiltradasSituacao: [],
            finalizacoesFiltradas: [],
            statusFinalizacoes: -1,
            statusFinalizacoesSelectBase: [
                { text: 'TODOS', value: -1 },
                { text: 'CRIADO', value: 0 },
                { text: 'EM APROVAÇÃO', value: 1 },
                // { text: 'EM APROVAÇÃO PELO GERENTE', value: 2 },
                // { text: 'EM APROVAÇÃO PELO ASSESSOR DARF', value: 3 },
                { text: 'EM PROCESSAMENTO PELO SETOR FINANCEIRO', value: 4 },
                { text: 'REPROVADO', value: 5 },
                // { text: 'REPROVADA PELO GERENTE', value: 6 },
                // { text: 'REPROVADA PELO ASSESSOR DARF', value: 7 },
                { text: 'REPROVADO PELO SETOR FINANCEIRO', value: 8 },
                { text: 'CONCLUÍDO', value: 9 },
                { text: 'AGUARDANDO SETOR FINANCEIRO', value: 12 }
            ],
            statusFinalizacoesSelect: [],
            situacaoFinalizacoes: 2,
            situacoesFinalizacoesSelect: [
                { text: 'TODOS', value: 0 },
                { text: 'NÃO RECEBIDOS', value: 1 },
                { text: 'EM APROVAÇÃO', value: 2 },
                { text: 'APROVADOS', value: 3 }
            ],
            dataInicial: null,
            dataFinal: null,
            setInicial: true,
            totaisStatus: {}
        }
    },

    methods: {
        obterFinalizacoes() {
            this.$store.dispatch('addRequest')
            let filtroDto = {
                situacao: this.situacaoFinalizacoes,
                status: this.statusFinalizacoes,
                dataInicial: this.dataInicial
                    ? this.$moment(this.dataInicial, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : '',
                dataFinal: this.dataFinal
                    ? this.$moment(this.dataFinal, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : ''
            }
            FinalizacoesServicos.obterTodas(filtroDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.finalizacoes = response.data.finalizacoes
                        this.finalizacoesFiltradas = response.data.finalizacoes
                        this.totaisStatus = response.data.totaisStatus
                    } else {
                        this.$toast.error(
                            'Erro ao obter finalizações',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        checarDetalharFinalizacao(finalizacao) {
            if (this.$temAcesso('CRED-UFI-FIN-00')
                && finalizacao.status == finalizacoesStatus.AGUARDANDO_SETOR_FINANCEIRO   
            ) {
                this.processarReprovar(finalizacao)
            } else {
                this.detalharFinalizacao(finalizacao.finalizacaoId)                
            }
        },

        processarReprovar(finalizacao) {
            this.$store.dispatch('addRequest')
            let aprovaReprovaFinalizacaoDto = {
                finalizacaoId: finalizacao.finalizacaoId,
                acao: 'A',
                detalheReprovacao: null,
                perfil: perfil.FINANCEIRO
            }
            FinalizacoesServicos
                .aprovarReprovarFinalizacao(aprovaReprovaFinalizacaoDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.detalharFinalizacao(finalizacao.finalizacaoId)                    
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        detalharFinalizacao(id) {
            this.$router.push({
                name: `Uabs_Finalizacoes_Detalhar`,
                params: {
                    finalizacaoId: id
                }
            })
        },

        processarFiltroStatus(regra) {
            let situacoesPorRegra = StatusPorSituacao.filter(item => {
                return item.regra == regra
            })

            let situacao = situacoesPorRegra[0].situacoes.filter(item => {
                return item.id == this.situacaoFinalizacoes
            })

            this.statusFinalizacoesSelect = this.statusFinalizacoesSelectBase.filter(
                item => {
                    return situacao[0].status.some(p => p == item.value)
                }
            )

            if (
                !this.statusFinalizacoesSelect.some(
                    p => p.value == this.statusFinalizacoes
                )
            ) {
                this.statusFinalizacoes = -1
            } else {
                this.obterFinalizacoes()
            }
        },

        processarFiltroSituacao() {
            if (this.situacaoFinalizacoes === 0) {
                this.finalizacoesFiltradasSituacao = this.finalizacoes.slice()
                this.statusFinalizacoesSelect = this.statusFinalizacoesSelectBase.slice()
                this.obterFinalizacoes()
            } else if (this.$temAcessoView('CRED-UABS-FIN-04')) {
                this.processarFiltroStatus('CRED-UABS-FIN-04')
            } else if (this.$temAcessoView('CRED-UABS-FIN-03')) {
                this.processarFiltroStatus('CRED-UABS-FIN-03')
            } else if (this.$temAcessoView('CRED-UABS-FIN-02')) {
                this.processarFiltroStatus('CRED-UABS-FIN-02')
            } else if (this.$temAcessoView('CRED-UFI-FIN-00')) {
                this.processarFiltroStatus('CRED-UFI-FIN-00')
            }
        }
    },

    created() {
        let dataAtual = new Date()
        this.dataInicial = this.$moment(dataAtual)
            .startOf('month')
            .format('DD/MM/YYYY')
        this.dataFinal = this.$moment(dataAtual)
            .endOf('month')
            .format('DD/MM/YYYY')
        this.setInicial = false
        this.processarFiltroSituacao()
    },

    computed: {
        mostrarFinalizacoes() {
            return this.$route.name === 'Uabs_Finalizacoes'
        }
    },

    watch: {
        $route(to) {
            if (to.name === 'Uabs_Finalizacoes') {
                this.obterFinalizacoes()
            }
        },

        statusFinalizacoes() {
            this.obterFinalizacoes()
        },

        situacaoFinalizacoes() {
            this.processarFiltroSituacao()
        },

        dataInicial() {
            if (this.dataInicial) {
                this.$refs.dp02.dp.minDate(this.dataInicial)
            } else {
                this.$refs.dp02.dp.minDate(false)
            }
            if (!this.setInicial) {
                this.processarFiltroSituacao()
            }
        },

        dataFinal() {
            if (this.dataFinal) {
                this.$refs.dp01.dp.maxDate(this.dataFinal)
            } else {
                this.$refs.dp01.dp.maxDate(false)
            }
            if (!this.setInicial) {
                this.processarFiltroSituacao()
            }
        }
    },

    components: {
        AppFinalizacoes: Finalizacoes
    }
}
</script>
